import SvgMapper from "../../../features/common/SvgMapper";
import InfoCardSelector from "../../../features/common/InfoCardSelector";
import {
  BUSSINESS_TYPES,
  ORGANIZATION_TYPES,
} from "../../../constants/Constants";
import { useSelector } from "react-redux";
import "../../Style.css";

const MixMatchParameters = ({
  industryOption,
  onChange,
  interviewRoleOption,
}) => {
  const {
    industryType,
    businessType,
    interviewRole,
    organizationType,
  } = useSelector((state) => state.interviewconfig);
  return (
    <div className="mix-match-parameters-section">
      <div className="mix-match-parameters-header">
        <div className="mix-match-parameters-number-badge">
          2
        </div>
        <h3 className="mix-match-parameters-title">
          Mix & Match Parameters
        </h3>
        <span className="mix-match-parameters-subtitle">
          (Create unique combinations)
        </span>
      </div>

      <div>
        <label className="mix-match-parameters-label">
          {SvgMapper.build("w-4 h-4 mr-2")}
          Industry Type <span className="mix-match-parameters-asterisk">*</span>
        </label>
        <div className="mix-match-parameters-grid-industry">
          {industryOption?.map((option) => (
            <button
              key={option.value}
              type="button"
              name="industryType"
              className={`mix-match-parameters-button mix-match-parameters-button-industry ${
                industryType === option.id
                  ? "mix-match-parameters-button-industry-selected"
                  : ""
              }`}
              onClick={() =>
                onChange({
                  target: { name: "industryType", value: option.id },
                })
              }
            >
              {option.value}
            </button>
          ))}
        </div>
      </div>

      <InfoCardSelector
        label="Business Type (Optional)"
        name="businessType"
        icon={SvgMapper.businessIcon("w-4 h-4 mr-2")}
        options={BUSSINESS_TYPES}
        hoverColor="green"
        onChange={onChange}
        selectedOption={businessType}
      />

      <InfoCardSelector
        label="Organization Type (Optional)"
        name="organizationType"
        icon={SvgMapper.organizationIcon("w-4 h-4 mr-2")}
        options={ORGANIZATION_TYPES}
        hoverColor="purple"
        onChange={onChange}
        selectedOption={organizationType}
      />
      <div>
        <label className="mix-match-parameters-label">
          {SvgMapper.interviewIcon("w-4 h-4 mr-2")}
          Interviewer Role <span className="mix-match-parameters-asterisk">*</span>
        </label>
        <div className="mix-match-parameters-grid-role">
          {interviewRoleOption?.map((option) => {
             const isSelected = interviewRole === option?.id;
            return (
              <button
                key={option.id}
                type="button"
                name="interviewRole"
                className={`mix-match-parameters-button mix-match-parameters-button-role ${
                  isSelected
                    ? "mix-match-parameters-button-role-selected"
                    : ""
                }`}
                onClick={() =>
                  onChange({
                    target: { name: "interviewRole", value: option?.id },
                  })
                }
              >
                {option.value}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MixMatchParameters;
